
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Neurology Doctors",
      queryName: "Neurology",
      teamName: "Neurology team",
    };
  },
  components: { DoctorsList },
});
